import { Pipe, PipeTransform } from '@angular/core';
import { hasLink, Resource } from '@ngxp/rest';

@Pipe({
	name: 'hasResourceLink',
	standalone: false,
})
export class HasResourceLinkPipe implements PipeTransform {
	transform(resource: Resource, link: string) {
		return hasLink(resource, link);
	}
}
